import {
  Box,
  Card,
  Modal,
  Stack,
  Typography,
  List,
  ListItem,
  ListItemButton,
  Avatar,
  ListItemText,
  IconButton
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_USERS_WORK_HISTORY } from "../../constant/Apipath";
import Removeduplicates from "../common/Removeduplicate";
import { getFormattedAddress } from "../common/GetFormattedAddress";
import Loader from "../../common/Loader";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

export default function Projectlist(props) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [userSites, setUserSites] = useState([]);
  const [noCompanyUserSites, setNoCompanyUserSites] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const LanguageData = multiLanguageData?.Expenses || {};
  const {
    TEXT_CHOOSE_A_PROJECT = English.Expenses.TEXT_CHOOSE_A_PROJECT,
    TEXT_PLEACEHOLDER = English.Expenses.TEXT_PLEACEHOLDER,
    TEXT_NO_COMPANIES = English.Expenses.TEXT_NO_COMPANIES
  } = LanguageData || {};
  const getUserworkhistory = async () => {
    try {
      setIsLoading(true);
      const workHistoryObj = {
        FullSearch: "",
        IncludeRecordNr: false,
        SearchList: [{ Id: 0, UserId: loginData?.userInformation?.UserId }],
        NrOfRecPerPage: 0
      };
      const userSitesRes = await Postrequestcall(
        FETCH_USERS_WORK_HISTORY,
        workHistoryObj,
        loginData?.accessToken
      );

      if (userSitesRes?.status === 201) {
        let userSites = Removeduplicates(userSitesRes?.data?.data, "projectId");
        let updatedUserSites = userSites?.map((element) => ({
          ...element,
          siteAddress: element?.address,
          siteCity: element?.city,
          siteProvince: element?.province,
          sitePostalCode: element?.postalCode,
          siteCountry: element?.country
        }));

        setNoCompanyUserSites(
          updatedUserSites?.filter((comp) => comp?.companyId === 0 || comp?.companyName === "")
        );
        setUserSites(
          updatedUserSites?.filter((comp) => comp?.companyId !== 0 || comp?.companyName !== "")
        );
      }
      setIsLoading(false);
    } catch (error) {
      console.error("getUserworkhistory-> Error When Fetching User Work History: ", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUserworkhistory();
  }, []);

  const getAddress = (params) => {
    const userAddress = {
      city: params?.siteCity,
      country: params?.siteCountry,
      province: params?.siteProvince,
      postalCode: params?.sitePostalCode,
      address: params?.siteAddress
    };
    let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
            /\w*/g,
            (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };

  const renderJobList = (itemList) => {
    if (itemList.length === 0) {
      return (
        <Typography sx={{ p: 1 }} variant="h6">
          {TEXT_PLEACEHOLDER}
        </Typography>
      );
    } else {
      return itemList?.map((item, index) => (
        <Card
          key={index?.toString()}
          className="pagelist-content"
          sx={{ marginTop: "0px", padding: 1, pl: 1.5, cursor: "pointer" }}>
          <Typography variant="body1">{item?.companyName}</Typography>
          <ListItem alignItems="flex-start" sx={{ m: 0, p: 0, pt: 0.5 }} key={index?.toString()}>
            <ListItemButton
              alignItems="flex-start"
              sx={{ m: 0, p: 0 }}
              onClick={() => {
                props?.onSelectProject(item);
                props?.onClose();
              }}>
              <Avatar
                className="add-Timesheet-picture"
                variant="square"
                alt="contact-PictureUrl"
                src={item?.mainPictureUrl || PlaceholderImg}
              />
              <ListItemText
                sx={{ pl: 2, mt: 0, alignItems: "flex-start" }}
                primary={
                  <Typography variant="body1" maxWidth={"430px"} noWrap>
                    {item?.projectName}
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body2" maxWidth={"430px"} noWrap>
                      {item?.siteName}
                    </Typography>
                    <Typography variant="body2" maxWidth={"430px"} noWrap>
                      {getAddress(item)}
                    </Typography>
                  </Box>
                }
              />
            </ListItemButton>
          </ListItem>
        </Card>
      ));
    }
  };

  return (
    <Modal open={props?.isOpen}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_CHOOSE_A_PROJECT}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={() => props?.onClose()}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>

        <Box
          sx={{
            paddingBottom: "10px",
            maxHeight: 555,
            minHeight: 440,
            overflow: "auto",
            scrollbarWidth: "none"
          }}>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: 555
              }}>
              <Loader />
            </div>
          ) : (
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >{renderJobList(userSites)}</Stack>
              {noCompanyUserSites?.length !== 0 ? (
                <>
                  <Typography sx={{ p: 1 }} variant="h6">
                    {TEXT_NO_COMPANIES}
                  </Typography>
                  <Stack sx={{ gap: 1 }} >{renderJobList(noCompanyUserSites)}</Stack>
                </>
              ) : null}
            </List>
          )}
        </Box>
      </Box>
    </Modal>
  );
}

